'use client';

import React from 'react';

import FilterRadioStyled from './FilterRadio.styled';

interface FilterRadioProps {
  checked: boolean;
  id: string;
  name: string;
  value: string;
  label: string;
  onChange: () => void;
}

const FilterRadio = ({ checked = true, id, name, value, label = '기본', onChange }: FilterRadioProps) => {
  return (
    <FilterRadioStyled.RadioLabel checked={checked}>
      <FilterRadioStyled.HiddenInput
        type="radio"
        id={id}
        name={name}
        value={value}
        checked={checked}
        onChange={onChange}
        aria-checked={checked}
      />
      {label}
    </FilterRadioStyled.RadioLabel>
  );
};

export default FilterRadio;
